import { render, staticRenderFns } from "./districts.vue?vue&type=template&id=222d2f58&"
import script from "./districts.vue?vue&type=script&lang=js&"
export * from "./districts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports